export const buttonLabels = {
  myAnalysisSearch: "go to my analysis search page",
  changePlan: "go to stripe change plan page",
  payment: "go to stripe payment page",
  signup: "go to sign up page",
} as const;
